module.exports = __webpack_public_path__ + "img/ru.c49b9812.svg";